import * as Sentry from '@sentry/nextjs';
import { ErrorCode } from '@lib/errors/error-code';

/**
 * Capture an error code to Sentry with message information
 */
export function captureErrorCode(errorCode: ErrorCode, message: string) {
  Sentry.captureException(new Error(`[${errorCode}] ${message}`), scope => {
    scope.setTags({
      'error-code': errorCode,
      'force-send': true,
    });
    scope.setExtras({
      component: message,
      errorType: errorCode,
    });

    return scope;
  });
}

/**
 * Capture an error to Sentry which is force sent.
 */
export function captureError(error: Error, errorCode?: ErrorCode) {
  Sentry.captureException(error, scope => {
    const tags: Record<string, any> = {
      'force-send': true,
    };

    if (errorCode) {
      tags['error-code'] = errorCode;
    }

    scope.setTags(tags);

    if (errorCode) {
      scope.setExtras({
        errorType: errorCode,
      });
    }

    return scope;
  });
}
